import Service from "../../services";

const authModule = {
  namespaced: true,
  state: {
    user: null,
    accessToken: null,
    permission: {},
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.accessToken = token;
    },

    SET_USER: (state, user) => {
      state.user = user;
    },
    SET_PERMISSION: (state, permission) => {
      state.permission = permission;
    },
  },
  actions: {
    login({ commit }, data) {
      return Service.auth.login(data).then((data) => {
        commit("SET_TOKEN", data.access_token);
        return data;
      });
    },
    setUser({ commit, state }) {
      if (state.accessToken == null) {
        return Promise.reject("No access token.");
        // console.log("llll");
      }

      return Service.auth
        .getUser()
        .then((data) => commit("SET_USER", data))
        .catch((err) => Promise.reject(err));
    },
    logout({ commit }) {
      return Service.auth.logout().then(() => {
        commit("SET_USER", null);
        commit("SET_TOKEN", null);
        commit("SET_PERMISSION", {});
      });
    },
    setPermission({ commit }) {
      return Service.auth.checkAllPermission().then((data) => {
        commit("SET_PERMISSION", data);
      });
    },
  },
  getters: {
    getUser(state) {
      return state.user;
    },
    getPermissions(state) {
      return state.permission;
    },
  },
};

export default authModule;
